export default __webpack_public_path__ + "static/media/62548266dcc0a60d.f342e357733602c00c42982ccff2d880.svg";